export const getMessage = (
  conditions: Array<{ check: boolean; message: string }>,
  options?: { fallback?: string },
) => {
  return conditions.find(condition => condition.check)?.message || options?.fallback || '';
};
